import { render, staticRenderFns } from "./AddTestmonialComponent.vue?vue&type=template&id=fdc12d2e"
import script from "./AddTestmonialComponent.vue?vue&type=script&lang=js"
export * from "./AddTestmonialComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports